import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { SUBMOTIVE1, SUBMOTIVE1_DETAIL } from '../../../../../routes/paths';
import {
    asyncGetParam,
    asyncGetSubmotive1Historical,
    asyncPatchSubmotive1Param,
    asyncPostSubmotive1Param,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { Param, ParamHistorical } from '../../../../../shared/types/param';

export const useSubmotive1Form = () => {
    const navigate = useNavigate();
    const { idSubmotive1 } = useParams();
    const [submotive1, setSubmotive1] = useState<Param>();
    const [loading, setLoading] = useState(false);
    const [formikSubmotive1Data, setFormikSubmotive1Data] =
        useState<FormikProps<Param>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [submotive1Historical, setSuptypeDPHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikSubmotive1Data?.isValid;

    const handleCleanAndBack = () => {
        formikSubmotive1Data?.resetForm();
        navigate(SUBMOTIVE1);
    };

    const handleSubmit = async () => {
        await formikSubmotive1Data?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Param = formikSubmotive1Data?.values;

        let res: any | undefined = undefined;

        try {
            if (submotive1 && submotive1.id)
                res = await asyncPatchSubmotive1Param(submotive1.id, data);
            else res = await asyncPostSubmotive1Param(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! el submotivo 1 se ${
                    submotive1 && submotive1.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${SUBMOTIVE1_DETAIL}/${item.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    submotive1 && submotive1.id ? 'actualizar' : 'crear'
                } el submotivo 1. Por favor, asegúrate de ${
                    submotive1 && submotive1.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idSubmotive1)) {
            setLoading(true);
            asyncGetParam(idSubmotive1)
                .then((submotive1: any) => {
                    if (!submotive1 || !submotive1.items) navigate(SUBMOTIVE1);
                    setSubmotive1(submotive1?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idSubmotive1]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetSubmotive1Historical(idSubmotive1)
                .then((resp) => {
                    if (resp) setSuptypeDPHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        submotive1,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikSubmotive1Data,
        submotive1Historical,
        showHistorical,
        setShowHistorical,
    };
};
